import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { ParentsListTable } from './parents-list-table';

export function ParentsListPage() {
  return (
    <div className='pt-4'>
      <Link className='mb-8 flex items-center gap-2' to='/dashboard'>
        <CircleArrowLeft className='size-6' />
        <span className='text-lg font-semibold'>Back to Dashboard</span>
      </Link>

      <div className='border-t px-4 pt-8'>
        <ParentsListTable />
      </div>
    </div>
  );
}
